import { withAuthenticationRequired } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';
import React from 'react';
import AllCarrierGroups from '@app/pages/customer/carriergroups/AllCarrierGroups.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';
import { PermissionTypesEnum } from '@api/ringil-api.v2.tsx';

const CarrierGroupsPage = () => {
  const { t } = useTranslation('common');
  return (
    <ResponsiveLayout title={t(`CarrierGroup.carrierGroups`, `Skupiny dopravců`)} oneOfPermission={[PermissionTypesEnum.PERMISSION_CARRIER_GROUP_READ, PermissionTypesEnum.PERMISSION_CARRIER_GROUP_RW]}>
      <AllCarrierGroups />
    </ResponsiveLayout>
  );
};

export default withAuthenticationRequired(CarrierGroupsPage);
